<template lang="html">
  <div style="background-color: #ffffff;">
    <div class="yellow-background" v-if="!mobile">
      <v-container class="parallax-container" style="padding-right: 7rem;">
        <v-layout class="about-center-container">
          <v-flex xs12 sm7 md6 lg4 xl4 class="about-flex">
            <h3 class="about-subtitle text-xs-left">Blitzoo is a game studio specializing in high-quality social casino-style games for desktop and mobile platforms.</h3>

            <br>
            <p class="body-text text-xs-left">Founded in 2016, Blitzoo brings over a decade of expertise in developing interactive mobile and web experiences. Our team has extensive experience in the gaming industry, including providing B2C serviecs to land-based slot game manufacturers, helping them transition their content to the digital marketplace.</p>

            <v-btn round color="#fd00b5" class="text-capitalize first-btn about-btn" style="margin-left: -0.5rem;" to="/working-at-ksg"><span class="about-btn-text"><strong>WORKING AT BLITZOO</strong></span></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-else>
      <v-container class="parallax-container-mobile">
        <v-layout class="about-center-container">
          <v-flex xs12 sm8 md6 lg4 xl4 class="about-flex">
            <h3 class="about-subtitle text-xs-left">Blitzoo is a game studio specializing in high-quality social casino-style games for desktop and mobile platforms.</h3>

            <br>
            <p class="body-text text-xs-left">Founded in 2016, Blitzoo brings over a decade of expertise in developing interactive mobile and web experiences. Our team has extensive experience in the gaming industry, including providing B2C serviecs to land-based slot game manufacturers, helping them transition their content to the digital marketplace.</p>

            <v-btn round outline color="#04307a" class="text-capitalize first-btn about-btn" style="margin-left: -0.5rem;" to="/working-at-ksg"><strong>WORKING AT BLITZOO</strong></v-btn>

            <v-img
              :src="mobileBackground01"
              min-width="100%"
              contain
            ></v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div class="last-container" v-if="!mobile && !ipad">
      <!-- style="top: -45px; margin-bottom: -45px;" -->
      <v-img :src="require('../assets/About/BackgroundImage_03.png')">
        <v-container class="parallax-container overlapContainer">
          <v-layout class="about-center-container">
            <v-flex xs9 sm6 md5 lg4 xl4 class="about-flex last-flex">
              <h1 class="parallax-last-header text-xs-left">Social Casino Gaming</h1>

              <br>
              <p class="social-casino-text text-xs-left">Social casinos bring the thrill of classic casino games-such as slots, poker, and blackjack-into the online world, but with a key difference: they use virtual currency instead of real money.</p>

              <p class="social-casino-text text-xs-left">Beyond gameplay, social casinos foster a sense of community. Players can connect with others who share their interests, challenge friends, and compete for leaderboard rankings, adding a competitive and interactive element to the experience.</p>

              <v-btn round color="#b400fb" class="parallax-button-text about-btn text-capitalize" style="margin-left: -0.5rem;" to="/social-games"><strong>SOCIAL CASINOS</strong></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
    </div>
    <div v-else-if="mobile && !ipad">
      <v-parallax
        :src="mobileBackground03"
      >
        <v-container class="parallax-container" style="padding-left: 0;">
          <v-layout class="about-center-container-mobile align-center">
            <v-flex xs10 sm6 md5 lg4 xl3 class="about-flex last-flex">
              <h1 class="parallax-last-header text-xs-left">Social Casino Gaming</h1>

              <br>
              <p class="social-casino-text text-xs-left">Social casinos bring the thrill of classic casino games-such as slots, poker, and blackjack-into the online world, but with a key difference: they use virtual currency instead of real money.</p>

              <p class="social-casino-text text-xs-left">Beyond gameplay, social casinos foster a sense of community. Players can connect with others who share their interests, challenge friends, and compete for leaderboard rankings, adding a competitive and interactive element to the experience.</p>

              <v-btn round color="#b400fb" class="parallax-button-text about-btn text-capitalize" style="margin-left: 0;" to="/social-games"><strong>SOCIAL CASINOS</strong></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-parallax>
      <!-- </v-img> -->
    </div>
    <div v-else>
      <v-parallax
        :src="mobileBackground03"
      >
        <v-container class="parallax-container">
          <v-layout class="align-center">
            <v-flex xs8 sm6 md5 lg4 xl3 class="about-flex">
              <h1 class="parallax-last-header text-xs-left">Identifying &amp; creating new market trends.</h1>

              <br>
              <p class="text-xs-left">We know what players want because we're players ourselves. We are constantly pushing the envelope by inventing new ways to play, coming up with fresh game themes, and always protecting our ideas.</p>

              <p class="text-xs-left">You can now experience our games from anywhere with our social casino!</p>

              <v-btn round color="#335091" class="parallax-button-text about-btn text-capitalize" style="margin-left: 0;" to="/social-games"><strong>Social Games</strong> <v-icon>chevron_right</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-parallax>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('mobile') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  data () {
    return {
      images: [
        // require('../assets/thumbnails/Thumb_BlackStallion.jpg'),
        require('../assets/thumbnails/Thumb_SnowDay.jpg'),
        require('../assets/thumbnails/Thumb_FirePearl.jpg'),
        require('../assets/thumbnails/Thumb_FishingBob.jpg'),
        require('../assets/thumbnails/Thumb_HotRoll.jpg'),
        require('../assets/thumbnails/Thumb_JadeFortune.jpg'),
        require('../assets/thumbnails/Thumb_Lobstermania.jpg')
      ],
      mobileBackground01: require('../assets/About/BackgroundImage_01_Trimmed.png'),
      mobileBackground03: require('../assets/About/BackgroundImage_03_Trimmed.png')
    }
  },
  methods: {
    test (e) {
      console.log(e)
      debugger
    }
  }
}
</script>

<style lang="scss" scoped>
.about-container {
  background-color: rgba(0,0,0,0.1);
}

.about-text-container {
  display: grid;
  justify-content: center;
}

.about-btn {
  font-family: 'open-sans-extrabold', serif;
}

.about-btn-text {
  color: #ffffff;
}

.about-subtitle {
  font-family: 'open-sans-bold', serif;
  font-size: 1.7rem;
  color: #120035;
  line-height: 1.15;
}

.body-text {
  font-size: 18px;
  color: black;
}

.social-casino-text {
  // font-size: 18px;
  font-size: 14px;
  color: white;
}

.flex.xs12.sm6.md4.lg4 {
  // get rid of spacing in between images
  padding: 0;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}

.transition-fast-in-fast-out {
  -webkit-transition: .9s cubic-bezier(.25,.8,.25,1)!important;
  transition: .9s cubic-bezier(.25,.8,.25,1)!important;
}

#outer-container {
  display: grid;
  justify-content: center;
}

#wrap-container {
  // color: white;
  text-align: left;
  width: 70vw;
}

#title {
  margin-bottom: 2rem;
}

.yellow-background {
  background:
    url('../assets/About/BackgroundImage_01.png') 75% 100%/contain no-repeat,
    url('../assets/About/BackgroundImage_02.png') center/cover no-repeat;
}

.first-container {
  background-image: url('../assets/About/BackgroundImage_01.png');
  // background-attachment: fixed;
  // background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 75% 100%;
}

.first-container img {
  margin-left: 10rem;
}

.first-btn {
  padding: 0 2.5rem;
}

.parallax {
  background-image: url('../assets/About/BackgroundImage_01.png');
  // min-height: 500px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.parallax-container {
  // width: 30%;
  display: flex;
  flex-direction: column;
  // align-items: flex-start;
  justify-content: center;
}

.parallax-container-mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 0;
}

.parallax-container-center {
  // width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.parallax-middle-header {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.7rem;
  align-self: stretch;
  // letter-spacing: -1.5px;
  line-height: 1.15;
}

.parallax-last-header {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.2rem;
  align-self: stretch;
  // letter-spacing: -1.5px;
  line-height: 1.15;
}

.parallax-button-text {
  color: white;
  padding: 0 4rem;
}

.overlapContainer {
  color: white;
  // width: 25%;
  padding: 0;
  padding-top: 5rem;
  // padding-right: 10rem;
  // margin-left: 35%;
}

.about-center-container {
  display: flex;
  justify-content: center;
}

.about-center-container-mobile {
  display: flex;
  justify-content: flex-start;
}

.about-flex {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.last-flex {
  margin-left: -2rem;
}

.last-container {
  background-color: #212121;
}

.overlapParallax {
  z-index: 999;
}

@media only screen and (max-width: 400px) {
  .parallax-container-center {
    padding-left: 0;
    padding-right: 0;
  }
}

@media only screen and (max-width: 600px) {
  .last-flex {
    margin-left: 0;
  }
}

@media only screen and (max-width: 1500px) {
  .overlapContainer {
    padding-bottom: 5rem;
  }
}
</style>
